import { Span } from '@fareye/ui'
import React from 'react'
import { MMStopsDetails } from './../../style/styled'
import { FieldValue } from './FieldValue'
import { displayTimeSecondFormat } from './function'
import { useTranslation } from '@fareye/common'
import { valueColor } from '@fareye/configs'
import { startCase } from '@fareye/utils'

export function DestinationDetails({
  rowData,
  positionStyle,
  transportMode
}: any) {
  const { stops, nodes, inState } = rowData || {}
  const completedFlag = inState === 'completed'
  const { locationName: name, city } = rowData?.endLocation || {}
  const { t } = useTranslation()
  let len = (stops || nodes).length
  let { state, eta, atd, ata, sta, std, status, statusToDestination, statusAtDestination } =
    (stops || nodes)[len - 1] || {}
  return (
    <MMStopsDetails className="popover" style={{ ...positionStyle }}>
      <FieldValue
        style={{ marginBottom: 0 }}
        labelStyle={{
          color: valueColor,
          fontWeight: 500
        }}
        label={`${t('Destination')}`}
        value={city || '-'}
      />
      <Span variant="ellipsis secondary" style={{ marginBottom: 4 }}>
        {name}
      </Span>
      <FieldValue
        style={{ marginBottom: 4 }}
        labelStyle={{
          color: valueColor,
          fontWeight: 500
        }}
        label={`${t('Trip State')}`}
        value={t(state) || '-'}
      />
      <FieldValue
        style={{ marginBottom: 4 }}
        labelStyle={{ color: valueColor, fontWeight: 500 }}
        label={`${t('Arrival Status')}: `}
        value={startCase(t(statusToDestination)) || '-'}
      />
      <FieldValue
        style={{ marginBottom: 4 }}
        labelStyle={{ color: valueColor, fontWeight: 500 }}
        label={`${t('Departure Status')}: `}
        value={startCase(t(statusAtDestination)) || '-'}
      />
      <FieldValue
        style={{ marginBottom: 4 }}
        valueStyle={{ color: valueColor }}
        label="STA"
        value={displayTimeSecondFormat(sta)}
      />
      <FieldValue
        style={{ marginBottom: 4 }}
        valueStyle={{ color: valueColor }}
        label={ata?.time || completedFlag ? 'ATA' : 'ETA'}
        value={
          ata?.time || completedFlag
            ? displayTimeSecondFormat(ata)
            : displayTimeSecondFormat(eta)
        }
      />
      {transportMode === 'ocean' ? (
        <FieldValue
          style={{ marginBottom: 4 }}
          valueStyle={{ color: valueColor }}
          label="STD"
          value={displayTimeSecondFormat(std)}
        />
      ) : null}
      {transportMode === 'ocean' ? (
        <FieldValue
          style={{ marginBottom: 4 }}
          valueStyle={{ color: valueColor }}
          label="ATD"
          value={displayTimeSecondFormat(atd)}
        />
      ) : null}
    </MMStopsDetails>
  )
}
